import md5 from 'md5';
import cmp from './cmp-s1';
import dpl from './dpl';
import clearCookies from './clear-cookies';

window.md5 = md5;

cmp.enqueue(
  () => console.log('This code only runs when no CMP needs to load, or when the CMP consent has been accepted. '),
  1
);
cmp.enqueue(() => console.log('This code only runs in GDPR when consent has been rejected.'), 0);

// Clear Cookies when no consent was given
cmp.enqueue(clearCookies, 0);

// CLear local storage when no consent was given
cmp.enqueue(() => {
  window.localStorage.clear();
  console.log('CLEARING LOCAL STORAGE.');
}, 0);

// initialize dpl.
if (!window.location.host.includes('system1.com') && !window.location.host.includes('reviews.howstuffworks.com')) {
  cmp.enqueue(dpl, 1);
}
